import { type ReactNode } from 'react';
import styles from './FormField.module.css';

interface Props {
  label?: string;
  hint?: string;
  error?: string;
  required?: boolean;
  children: ReactNode;
}

export const FormField = ({ label, hint, error, required, children }: Props) => (
  <div className={styles.field}>
    {label && (
      <label className={styles.label}>
        {label}
        {required && <span className={styles.required}>*</span>}
      </label>
    )}
    {children}
    {error ? (
      <p className={styles.error}>{error}</p>
    ) : hint ? (
      <p className={styles.hint}>{hint}</p>
    ) : null}
  </div>
);